export default __webpack_public_path__ + "static/media/kitchen2.2da3b10e.jpg";